import { useSelector } from '../../../store/hooks'
import { BuyersData } from '../../../modules/buyers/types'
import { useNavigate, useParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './BuyerHeader.styles'
import { LoadingTypes, isLoading, resolveBuyerLogoUrl } from '@labrav/common'
import {
  StatusChipBg,
  StatusChipText,
  StatusChipV3,
} from '@labrav/react-components'

export const BuyerHeader = () => {
  const { classes } = useStyles()
  const navigate = useNavigate()
  const { accountId } = useParams<{
    accountId?: string
  }>()
  const { buyers } = useSelector<BuyersData>(state => state.BuyersOverView)
  const isBuyersPageLoading = useSelector<boolean>(state =>
    isLoading(state.loading)(LoadingTypes.BUYERS_OVERVIEW)
  )
  const buyer = buyers[0]

  const handleBack = () => {
    const buyersPath = accountId
      ? `/flyout/aws/${accountId}/buyers`
      : '/flyout/buyers'
    navigate(buyersPath)
  }

  const name = buyer?.buyerInfo.companyName

  return (
    <>
      {!isBuyersPageLoading && (
        <div className={classes.header}>
          <FontAwesomeIcon
            icon={faArrowLeft}
            className={classes.backButton}
            onClick={handleBack}
          />
          {buyer?.buyerInfo?.logoUrl && (
            <img
              src={resolveBuyerLogoUrl(buyer.buyerInfo.logoUrl) ?? ''}
              crossOrigin="anonymous"
              className={classes.companyLogo}
              alt="Company logo"
            />
          )}
          <span data-testid={'company-name'} className={classes.companyName}>
            {name}
          </span>
          <StatusChipV3
            bgColor={
              buyer?.details?.activeContracts >= 1
                ? StatusChipBg.GREEN
                : StatusChipBg.RED
            }
            textColor={
              buyer?.details?.activeContracts >= 1
                ? StatusChipText.GREEN
                : StatusChipText.RED
            }
            label={buyer?.details?.activeContracts >= 1 ? 'Active' : 'Churned'}
            toolTipLabel={
              buyer?.details?.activeContracts >= 1 ? 'Active' : 'Churned'
            }
          />
        </div>
      )}
    </>
  )
}
